$(function(){
  enableSliderButton();
  fixedPdpThumbnailPos();
  initDate();
    autoAddGwp();
    autoTierGwp();
    gwpColMinCartQty();
    fixedPdpThumbnailPos();
    updateShippingProgress();
    updateGwpSamppleProgress();
    bindGwpSampleCheckoutGuard();
    updateGwpSampleCheckoutState();
    autoSelectGwpSamples();
    maintainScrollPosition();
    openLinkNewTab();
    updateComplementaryArrow();
    updateMilestonePosition();
    toggleComplementaryArrow();
    buyXGetYGwp();
    removeInvalidFreeItems();
    klaviyoFormHeadingUpdate();
    // Use fast check on page load (works for both cart page and drawer)
    if (typeof checkGiftWrapInCartFast === 'function') {
      checkGiftWrapInCartFast();
    } else if (typeof checkGiftWrapInCart === 'function') {
      checkGiftWrapInCart();
    }
    jscInitGridVariantPillScrollInContext();
});

// start: gwp sample checkout guard (require exact sample count)
getGwpSampleCountLeft = () => {
  // Prefer the hidden marker rendered in cart page/cart drawer.
  var $marker = $('.__gwpsample-currenttier_countleft:last');
  if ($marker.length > 0) {
    var raw = $marker.attr('data-countleft');
    var parsed = parseInt(raw, 10);
    if (!Number.isNaN(parsed)) return parsed;
  }

  // Fallback to the visible text inside the sample section (if present).
  var $count = $('.jsc-gwpsample-section .jsc-gwpsample-count-left .count:first');
  if ($count.length > 0) {
    var parsedText = parseInt($count.text().trim(), 10);
    if (!Number.isNaN(parsedText)) return parsedText;
  }

  return null;
}

parseBooleanAttr = (raw) => {
  if (raw == null) return false;
  var val = raw.toString().toLowerCase().trim();
  return (val === 'true' || val === '1' || val === 'yes');
}

// If customer manually adjusts samples, pause auto-select until full page refresh.
setGwpSampleManualOverride = () => {
  window.__jscGwpSampleManualOverrideActive = true;
}

isGwpSampleManualOverrideActive = () => {
  return window.__jscGwpSampleManualOverrideActive === true;
}

isGwpSampleSelectionRequired = () => {
  // The marker is only rendered when the GWP sample feature is enabled.
  var $marker = $('.__gwpsample-currenttier_countleft:last');
  if ($marker.length == 0) return false;

  var raw = ($marker.attr('data-required') || '');
  if (parseBooleanAttr(raw)) return true;

  // Unknown/false: treat as not required to avoid blocking checkout unexpectedly.
  return false;
}

isGwpSampleAutoSelectEnabled = () => {
  var $marker = $('.__gwpsample-currenttier_countleft:last');
  if ($marker.length == 0) return false;
  return parseBooleanAttr($marker.attr('data-autoselect'));
}

setGwpSampleErrorVisible = (isVisible) => {
  var $error = $('.jsc-gwpsample-section .jsc-gwpsample-error-text:first');
  if ($error.length == 0) return;

  if (isVisible) {
    $error.removeClass('d-none');
  } else {
    $error.addClass('d-none');
  }
}

scrollToGwpSampleSection = () => {
  var $section = $('.jsc-gwpsample-section:first');
  if ($section.length == 0) return;

  var el = $section.get(0);

  // Single smooth scroll to avoid "jumping" (no follow-up scrollBy nudge).
  // Try to account for sticky header height if present.
  var headerOffset = 100;
  try {
    var $stickyHeader = $('sticky-header:visible:first');
    if ($stickyHeader.length > 0) {
      headerOffset = Math.max(headerOffset, $stickyHeader.outerHeight() || 0);
    } else {
      var $header = $('header:visible:first');
      if ($header.length > 0) headerOffset = Math.max(headerOffset, $header.outerHeight() || 0);
    }

    var rect = el.getBoundingClientRect();
    var absoluteTop = rect.top + (window.pageYOffset || document.documentElement.scrollTop || 0);
    var targetTop = Math.max(0, absoluteTop - headerOffset);

    // If we're already basically there, don't scroll again.
    if (Math.abs((window.pageYOffset || 0) - targetTop) < 8) return;

    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({ top: targetTop, left: 0, behavior: 'smooth' });
    } else {
      $('html, body').animate({ scrollTop: targetTop }, 350);
    }
  } catch (e) {
    // Fallback for older browsers
    $('html, body').animate({ scrollTop: $section.offset().top - headerOffset }, 350);
  }
}

disableCheckoutBriefly = (triggerEl, ms) => {
  var duration = ms || 1200;

  // Disable the clicked element, and also the main checkout button(s) to prevent double submits.
  var $targets = $('.jsc_cart__checkout');
  if (triggerEl) $targets = $targets.add($(triggerEl));

  $targets.each(function() {
    var $el = $(this);
    if ($el.is('button, input, select, textarea')) {
      $el.attr('disabled', true).addClass('is-disabled');
    } else {
      $el.attr('aria-disabled', 'true').addClass('is-disabled');
      $el.css('pointer-events', 'none');
    }
  });

  setTimeout(() => {
    $targets.each(function() {
      var $el = $(this);
      if ($el.is('button, input, select, textarea')) {
        $el.removeAttr('disabled').removeClass('is-disabled');
      } else {
        $el.removeAttr('aria-disabled').removeClass('is-disabled');
        $el.css('pointer-events', '');
      }
    });
  }, duration);
}

updateGwpSampleCheckoutState = () => {
  // Only applies when the sample section exists on the page.
  if ($('.jsc-gwpsample-section').length == 0) return;

  // If selection is not required, never show the blocking error.
  if (!isGwpSampleSelectionRequired()) {
    setGwpSampleErrorVisible(false);
    return;
  }

  var countLeft = getGwpSampleCountLeft();
  if (countLeft == null) return;

  // Hide the error once the user has met (or exceeded) the sample requirement.
  if (countLeft <= 0) {
    setGwpSampleErrorVisible(false);
  }
}

bindGwpSampleCheckoutGuard = () => {
  if (window.__jscGwpSampleCheckoutGuardBound) return;
  window.__jscGwpSampleCheckoutGuardBound = true;

  var blockIfSamplesMissing = (e, triggerEl) => {
    // Only block if the section is enabled/present.
    if ($('.jsc-gwpsample-section').length == 0) return true;

    // Only enforce when the theme setting requires selecting samples.
    if (!isGwpSampleSelectionRequired()) {
      setGwpSampleErrorVisible(false);
      return true;
    }

    var countLeft = getGwpSampleCountLeft();
    if (countLeft == null) return true;

    if (countLeft > 0) {
      if (e && e.preventDefault) e.preventDefault();
      if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();

      disableCheckoutBriefly(triggerEl, 1200);
      setGwpSampleErrorVisible(true);
      scrollToGwpSampleSection();
      return false;
    }

    // Requirement met; ensure error is hidden.
    setGwpSampleErrorVisible(false);
    return true;
  };

  // Handle clicks on checkout buttons/links.
  $(document).on('click', 'button[name="checkout"], input[name="checkout"], .jsc_cart__checkout, a[href="/checkout"]', function(e) {
    // Save cart note before checkout (form submit handler will also save it, but this ensures it's saved even if form is prevented)
    var noteInput = document.querySelector('#cart-note, textarea[name="note"]');
    if (noteInput) {
      var noteValue = noteInput.value || '';
      // Save note asynchronously (form submit handler provides backup)
      $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ note: noteValue })
      });
    }
    return blockIfSamplesMissing(e, this);
  });

  // Handle "Enter to submit" on cart forms (cart page + drawer).
  $(document).on('submit', 'form[action*="/cart"]', function(e) {
    var submitter = e.originalEvent && e.originalEvent.submitter ? e.originalEvent.submitter : null;
    if (submitter && $(submitter).is('[name="checkout"], .jsc_cart__checkout')) {
      return blockIfSamplesMissing(e, submitter);
    }
    return true;
  });

  // Keep state in sync after cart updates (AJAX cart drawer/cart page rerenders).
  $(document).on('cart.requestComplete cart:updated', function() {
    setTimeout(() => {
      updateGwpSampleCheckoutState();
      autoSelectGwpSamples();
    }, 200);
  });
}
// end: gwp sample checkout guard

// start: gwp sample auto select
cartAddItems = (items) => {
  if (!items || items.length == 0) return;

  showCartSpinner();

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ items: items })
  })
  .then(response => response.json())
  .then(() => {
    if (window.location.pathname === '/cart') {
      location.reload();
      return;
    }

    removeCartSpinner();
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      // Trigger drawer re-render; vid is not important here.
      updateCartDrawer(items[0].id, cartDrawer);
    }
  })
  .catch((error) => {
    console.error('Error auto selecting GWP samples:', error);
    removeCartSpinner();
  });
}

autoSelectGwpSamples = () => {
  // Only applies when the sample section exists on the page.
  if ($('.jsc-gwpsample-section').length == 0) return;
  if (!isGwpSampleAutoSelectEnabled()) return;
  // Don't auto-select while customer is manually adjusting sample choices.
  if (isGwpSampleManualOverrideActive()) return;
  if (window.__jscAutoSelectGwpSamplesRunning) return;

  var $marker = $('.__gwpsample-currenttier_countleft:last');
  if ($marker.length == 0) return;

  var requiredCount = parseInt($marker.attr('data-count'), 10);
  var countLeft = getGwpSampleCountLeft();
  if (Number.isNaN(requiredCount) || requiredCount <= 0) return;
  if (countLeft == null || countLeft <= 0) return;

  window.__jscAutoSelectGwpSamplesRunning = true;

  fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' })
    .then(r => r.json())
    .then(cart => {
      // Collect already-selected sample variant ids in cart to avoid duplicates.
      var existingSampleVariantIds = new Set(
        (cart.items || [])
          .filter(item => item.properties && item.properties['_GWP Sample'])
          .map(item => parseInt(item.id, 10))
          .filter(id => !Number.isNaN(id))
      );

      // Get candidate sample variant ids from the sample section, in order.
      var candidates = [];
      $('.jsc-gwpsample-section .__jsc-gwp-sample-atc[data-vid]').each(function() {
        var vid = parseInt($(this).attr('data-vid'), 10);
        if (Number.isNaN(vid)) return;
        if (existingSampleVariantIds.has(vid)) return;
        if (candidates.indexOf(vid) !== -1) return;
        candidates.push(vid);
      });

      var need = Math.min(countLeft, candidates.length);
      if (need <= 0) return;

      var items = [];
      for (var i = 0; i < need; i++) {
        items.push({
          id: candidates[i],
          quantity: 1,
          properties: { '_GWP Sample': 'Free Gift' }
        });
      }

      cartAddItems(items);
    })
    .catch(error => {
      console.error('Error checking cart for auto selecting samples:', error);
    })
    .finally(() => {
      // Allow another attempt later if needed.
      window.__jscAutoSelectGwpSamplesRunning = false;
    });
}
// end: gwp sample auto select

// Pause auto-select whenever customer interacts with sample selection UI.
$(document).on(
  'click',
  '.jsc-gwpsample-section .__jsc-gwp-sample-atc, .jsc-gwpsample-section .quantity__button, .jsc-cart-gwp-lineitems .quantity__button, .jsc-cart-gwp-lineitems cart-remove-button, .__remove-allgwp',
  function() {
    setGwpSampleManualOverride();
  }
);

// start: open external link in new tab
openLinkNewTab = () => {
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
}
// end: open external link in new tab

clickParentNav = (nav) => {
 var nav = $(nav);
 nav.parent('.js-btn').click();
}

fixedPdpThumbnailPos = () => {
    var $swiper = $('.product__media .swiper-thumbs-container .swiper-wrapper');
    var $swiperSlide = $($swiper).find('.swiper-slide');

    // Callback function to execute when mutations are observed
    const callback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                $swiper.removeAttr('style');
                console.log('Class changed:', $swiperSlide.length);
            }
        }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Attach the observer to each target node
    if($swiperSlide.length <= 5) {
        $swiperSlide.each(function(index, targetNode) {
            // Inside the each() callback, attach the observer to the current targetNode
            observer.observe(targetNode, { attributes: true, attributeFilter: ['class'] });
        });
    }
}
function onloadQuantity(itemId) {
    var errorMessage = document.querySelector('.cart-drawer__form #CartItem-' + itemId + ' .jsc-error-message');
    var errorMessageCartPage = document.querySelector('.cart__main #CartItem-' + itemId + ' .jsc-error-message');
  
    setTimeout(() => {
      var input = document.querySelector('.cart-drawer__form #CartItem-' + itemId + ' .quantity__input');
      var currentValue = parseInt(input.value);
      var maxValue = parseInt(input.getAttribute('max'));
  
      if (currentValue >= maxValue) {
        errorMessage.style.display = 'block';
      } else {
        errorMessage.style.display = 'none';
      }

      var inputCartPage = document.querySelector('.cart__main #CartItem-' + itemId + ' .quantity__input');
      var currentValueCartPage = parseInt(inputCartPage.value);
      var maxValueCartPage = parseInt(inputCartPage.getAttribute('max'));

      if (currentValueCartPage >= maxValueCartPage) {
        errorMessageCartPage.style.display = 'block';
      } else {
        errorMessageCartPage.style.display = 'none';
      }
    }, 1500); 
  }

  editAccountEdit = (e) =>{
    var _this = $(e);

    $('.jsc-static-info').hide();
    $('.jsc-klaviyo-form').show();
  }

  cancelUpdate = (e) =>{
    var _this = $(e);
    
    $('.jsc-klaviyo-form').hide();
    $('.jsc-static-info').show();
  }
  
  initDate = () =>{
    var startDate = new Date(1900, 1 - 1, 1);
    var currentDate = new Date();
    var endDate = new Date(new Date().getFullYear() - 12, currentDate.getMonth(), currentDate.getDate());
    
    if ($('#jsc-date-of-birth').length) {
      $('#jsc-date-of-birth').datepicker({
        dateFormat: 'dd/mm/yy',
        minDate: startDate,
        maxDate: endDate
      });
    }
  }

  updateProfile = (e) =>{
    var _this = $(e);
    var loader = $('.jsc-loader-overlay');

    loader.show();

    var firstName = $('#jsc-first-name').val();
    var lastName = $('#jsc-last-name').val();
    var dateOfBirth = $('#jsc-date-of-birth').val();
    var gender = $('#jsc-gender').val();
    var email = $('#jsc-email').val();
    var country = $('#jsc-country').val();

    var settings = {
      "url": "https://a.klaviyo.com/client/profiles/?company_id=wHzJ88",
      "method": "POST",
      "timeout": 0,
      "headers": {
        "content-type": "application/json",
        "revision": "2024-05-15"
      },
      "data": JSON.stringify({
        "data": {
          "type": "profile",
          "attributes": {
            "email": email,
            "first_name": firstName,
            "last_name": lastName,
            "properties": {
              "birthday": dateOfBirth,
              "Gender": gender,
              "country": country
            }
          }
        }
      }),
    };
    
    $.ajax(settings).done(function (response) {
      // console.log('Sumbit', response);
      setTimeout(() => {
        $('.ad-birthday').html(dateOfBirth);
        $('.ad-gender').html(gender);
        $('.ad-country').html(country);
        loader.hide();
        $('.jsc-static-info').show();
        $('.jsc-klaviyo-form').hide();
      }, 1200);
    });
  }
  // start: update cart shipping bar
  updateShippingProgress = () => {
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      var totalPrice = data.total_price;
      var threshold = parseInt($('.jsc-shipping-progress-bar.progress-bar .progress-bar__progress').attr('data-threshold'));
      var thresholdPercentage = totalPrice / threshold * 100;
      var progressBarWrapper = $('.jsc-shipping-progress-bar.progress-bar');
      var progressBarProgress = $('.jsc-shipping-progress-bar.progress-bar .progress-bar__progress-inner');
      var progressBarText = $('.jsc-shipping-progress-bar.progress-bar .progress-bar__text');

      if(data.item_count > 0 && threshold > 0) {
        progressBarWrapper.addClass('active');
        if(thresholdPercentage < 0) {
          thresholdPercentage = 0;
        }
        else if(thresholdPercentage > 100) {
          thresholdPercentage = 100;
        }

        progressBarWrapper.attr('data-progress', 'calc(' + thresholdPercentage + '% + 2px)');
        progressBarProgress.css('width', 'calc(' + thresholdPercentage + '% + 2px)');

        if(thresholdPercentage < 100) {
          var remainingAmount = (threshold - totalPrice) / 100;
          progressBarText.text('Only $' + remainingAmount.toFixed(2) + ' away from free shipping');
        }
        else {
          progressBarText.text("Congrats! You're qualified for free shipping!");
        }
      }
      else {
        progressBarWrapper.removeClass('active');
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  // end: update cart shipping bar

  // start: cart gwp sample ATC
  gwpSampleAtc = (e) => {
    // Customer is manually choosing a sample; pause auto-select.
    setGwpSampleManualOverride();
    var $gwp_prop = {};
    var $vid = parseInt($(e).attr('data-vid'));

    $gwp_prop['_GWP Sample'] = 'Free Gift';

    cartJSAdd($vid, 1, $gwp_prop);
  }

  minusQtySample = (key) => {
    // Customer is manually changing samples; pause auto-select.
    setGwpSampleManualOverride();
    $('.jsc-cart-gwp-lineitems .__minus_'+key).click();
  }

  addQtySample = (key) => {
    // Customer is manually changing samples; pause auto-select.
    setGwpSampleManualOverride();
    $('.jsc-cart-gwp-lineitems .__plus_'+key).click();
  }

  removeAllGwpSample = (keylist) => {
    // Customer is clearing samples; pause auto-select so they can re-pick.
    setGwpSampleManualOverride();
    var keysplit = keylist.split(",");
    var jsonObj = {};
    for (i=0;i<keysplit.length;i++){
        jsonObj[keysplit[i]] = 0;
    }
    console.log(jsonObj);
    CartJS.updateItemQuantitiesById(jsonObj);
  
    $(document).on('cart.requestComplete', function(event, cart) {
      location.reload();
    });

  }

  // end: cart gwp sample ATC

// start: update cart gwp sample bar
// updateGwpSamppleProgress = () => {

  
//   $.when($.getJSON('/cart.js', function(cart) {
//     cart_originaltotal = cart.original_total_price;
//     cart_totalcount = cart.item_count;
//   })).then(function(cart){
//       // console.log(cart,cart_originaltotal,'cart_originaltotal');
//       var currTierCount = parseInt($('.__gwpsample-currenttier_countleft:last').attr('data-count'));
//       var currTierCountLeft = parseInt($('.__gwpsample-currenttier_countleft:last').attr('data-countleft'));
//       // console.log(currTierCountLeft,'currTierCountLeft',$('.__gwpsample-currenttier_countleft:last'),'currTierCount',currTierCount);
    
//       if ((currTierCountLeft < 0) || (currTierCount < 1)) {
//         var gwpKeylist = $('.__remove-allgwp').attr('data-gwpKeylist');
//         if (gwpKeylist){
//           removeAllGwpSample(gwpKeylist);
//         }
//       }

//       var gwpsample_enabled = $('.jsc-gwpsample-section');
//       if (gwpsample_enabled.length > 0){
//         var totalPrice = cart_originaltotal;
//         var threshold = parseInt($('.jsc-gwpsample-section .progress-bar .progress-bar__progress').attr('data-threshold'));
//         var thresholdPercentage = totalPrice / threshold * 100;
//         var progressBarWrapper = $('.jsc-gwpsample-section .progress-bar');
//         var progressBarProgress = $('.jsc-gwpsample-section .progress-bar .progress-bar__progress-inner');
//         var progressBarText = $('.jsc-gwpsample-section .progress-bar .progress-bar__text');
     

//         if(cart_totalcount > 0 && threshold > 0) {
//           progressBarWrapper.addClass('active');
//           if(thresholdPercentage < 0) {
//             thresholdPercentage = 0;
//           }
//           else if(thresholdPercentage > 100) {
//             thresholdPercentage = 100;
//           }

//           progressBarWrapper.attr('data-progress', 'calc(' + thresholdPercentage + '% + 2px)');
//           progressBarProgress.css('width', 'calc(' + thresholdPercentage + '% + 2px)');

      //     if(thresholdPercentage < 100) {
      //       var remainingAmount = (threshold - totalPrice) / 100;
      //       progressBarText.html('Only $' + remainingAmount.toFixed(2) + ' away from getting a <b>COMPLIMENTARY SAMPLE!</b>');
      //     }
      //     else {
      //       progressBarText.html("Congrats! You're qualified for <b>" + currTierCount + " COMPLIMENTARY SAMPLE(S)!</b> - redeem now");
      //     }
      //   }
      //   else {
      //     progressBarWrapper.removeClass('active');
      //   }
      // }

//   });

// }
// end: update cart gwp sample bar


  // start: Cart Event
  cartJSAdd = (vid, qty, obj) => {
    CartJS.addItem(vid, qty, obj, {
      // Define a success callback to display a success message.
      "success": async function(data, textStatus, jqXHR) {
        $(document).on('cart.requestComplete', function(event, cart) {          ;
          if (window.location.pathname === '/cart') {
            location.reload();
            removeCartSpinner();
          }
          else {
            removeCartSpinner();
            var cartDrawer = document.querySelector('cart-drawer');
            updateCartDrawer(vid, cartDrawer);
            // Fast check for cart drawer
            if (typeof checkGiftWrapInCartFast === 'function') {
              checkGiftWrapInCartFast();
            }
          }
        });
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log('There was a problem adding to the cart!');
      
      }
    });
  }

  cartJSUpdate = (vid, qty, obj, disabledCheckoutBtn) => {
    // Cart js add item, success callback, error callback  
    CartJS.updateItemById(vid, qty, obj,
    {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          beforeSend: function() {
          },
          success: function(cart) {
            console.log(disabledCheckoutBtn,'disabledCheckoutBtn');
            if (disabledCheckoutBtn){
              console.log('dont enabel checkout yet');
              // don't enable the checkout button yet
            }else{
              removeCartSpinner();
            }

              if (window.location.pathname === '/cart') {
                if (disabledCheckoutBtn){
                  // don't enable the checkout button yet
                  console.log('dont enabel checkout yet');
                }else{
                  console.log('refresh cart pge...');
                  location.reload();
                }
              }
              else {
                var cartDrawer = document.querySelector('cart-drawer');
                updateCartDrawer(vid, cartDrawer);
                // Fast check for cart drawer
                if (typeof checkGiftWrapInCartFast === 'function') {
                  checkGiftWrapInCartFast();
                }
                $('.jsc-loader-overlay').hide();
              }
            
          }
        });
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        $('.jsc-loader-overlay').hide();
      }
    });
  }

  updateCartDrawer = (vid, cartDrawer) => {
    const formData = new FormData();
    formData.append('id', 19534838534);
    formData.append('quantity', 0);
    formData.append(
      'sections',
      cartDrawer
        .getSectionsToRender()
        ?.map(section => section.section)
    );
    formData.append('sections_url', window.location.pathname);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
    .then(response => response.json())
    .then(addToCartData => {
      cartDrawer.renderContents(addToCartData, true);
      // Fast check for cart drawer (renderContents already calls it, but this is a backup)
      if (typeof checkGiftWrapInCartFast === 'function') {
        setTimeout(() => {
          checkGiftWrapInCartFast();
        }, 200);
      }
    })
    .catch(error => {
      console.error('Error adding to cart or updating drawer:', error);
    });
  }
  // end: Cart Event

  // start: cart recommendation upsell
  cartUpsellAtc = (e) => {
    var vid = parseInt($(e).attr('data-vid'));
    cartJSAdd(vid, 1, {});
  }

  showUpsellVariants = (e) => {
    var variantWrapper = $(e).siblings('.cart-recommendations__item-variant-wrapper');
    variantWrapper.addClass('active');
    $(e).hide();
  }
  // end: cart recommendation upsell

  // start: store locator prevent scroll
  maintainScrollPosition = () => {
    var $storeMap = $('#storemapper');
    if($storeMap.length > 0) {
      const intervalId = setInterval(() => {
        var $viewMapBtn = $('#storemapper-list .storemapper_view');
        var $mapSearchBtn = $('#storemapper-go');

        if($viewMapBtn.length > 0) {
          clearInterval(intervalId);

          $viewMapBtn.each(function() {
            $(this).on('click', function() {
              var xpos = window.scrollX;
              var ypos = window.scrollY;

              setTimeout(() => {
                window.scrollTo(xpos, ypos);
              }, 100);
            });
          });

          $mapSearchBtn.on('click', function() {
            console.log('search click')
            var xpos = window.scrollX;
            var ypos = window.scrollY;

            setTimeout(() => {
              window.scrollTo(xpos, ypos);
            }, 100);
          });
        }
      }, 100);
    }
  }
  // end: store locator prevent scroll

  // start: reorder
  reorderAtc = (e) => {
    var vid = parseInt($(e).parent().parent().attr('data-vid'));
    console.log('atc', vid);
    cartJSAdd(vid, 1, {});
  }
  // end: reorder

// start: complementary slider arrow pos
updateComplementaryArrow = () => {
  var $complementaryContainer = $('.section-complete-the-set');
  var $complementarySec = $('complementary-products');
  if($complementarySec.length > 0) {
    var intervalId = setInterval(() => {
      var $productCards = $($complementarySec).find('.card-product-slider__slide');
      var $prevBtn = $($complementaryContainer).find('.swiper-button--prev');
      var $nextBtn = $($complementaryContainer).find('.swiper-button--next');
      var $slider = $($complementarySec).find('.card-product-slider__wrapper');

      if($productCards.length > 0) {
        var cardWidth = $productCards.first().width();
        var totalProducts = $productCards.length;
        var containerWidth = $complementarySec.width();
        var maxCard = 0;

        if($(window).width() > 1024) {
          maxCard = parseInt($complementarySec.attr('data-slides'));
        }
        else {
          maxCard = 3;
        }
        var visibleWidth = cardWidth * Math.min(totalProducts, maxCard);
        var offset = ((containerWidth - visibleWidth) / 2);
        var leftOffset = offset - 5;
        var rightOffset = offset + 5;

        if($(window).width() > 1024) {
          $prevBtn.css('left', leftOffset + 'px');
          $nextBtn.css('right', rightOffset + 'px');

          if($productCards.length > maxCard) {
            $slider.addClass('.justify-left');
          }
        }

        clearInterval(intervalId);
      }
    }, 100);

  }
}
// end: complementary slider arrow pos

// start: gwp auto add
autoAddGwp = () => {
  var $gwps = $('.jsc-auto-gwp');

  if ($gwps.length === 0) return;

  var parseExcludedIds = function (attr) {
    if (!attr || typeof attr !== 'string') return [];
    return attr.split(',').map(function (id) {
      return parseInt(String(id).trim(), 10);
    }).filter(function (n) {
      return !isNaN(n);
    });
  };

  var cartJsonHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  var root = window.Shopify.routes.root;
  var drawerHintVid = parseInt($gwps.first().attr('data-vid'), 10);

  fetch(root + 'cart.js', {
    method: 'GET',
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      var originalPrice = data.original_total_price;
      var updates = {};
      var pendingAddVid = {};
      var toAdd = [];

      $gwps.each(function () {
        var $el = $(this);
        var gwpVid = parseInt($el.attr('data-vid'), 10);
        var minSpend = parseInt($el.attr('data-min-spend'), 10);
        if (isNaN(gwpVid) || isNaN(minSpend)) return;

        var excludedProductIds = parseExcludedIds($el.attr('data-exclude-ids'));
        var excludedTotal = 0;
        data.items.forEach(function (item) {
          if (excludedProductIds.indexOf(item.id) !== -1) {
            excludedTotal += item.price * item.quantity;
          }
        });

        var finalTotal = originalPrice - excludedTotal;

        var gwpiInCart = data.items.find(function (item) {
          return item.id === gwpVid && item.properties && item.properties['_Promo'];
        });

        var gwpiInCartNoProperty = data.items.find(function (item) {
          return item.id === gwpVid && item.properties && !item.properties['_Promo'];
        });

        if (gwpiInCartNoProperty && gwpiInCartNoProperty.quantity > 0) {
          updates[gwpiInCartNoProperty.key] = 0;
        }

        if (finalTotal >= minSpend && !gwpiInCart) {
          if (!pendingAddVid[gwpVid]) {
            pendingAddVid[gwpVid] = true;
            toAdd.push(gwpVid);
          }
        } else if (finalTotal < minSpend && gwpiInCart) {
          updates[gwpiInCart.key] = 0;
        } else if (finalTotal >= minSpend && gwpiInCart && gwpiInCart.quantity > 1) {
          updates[gwpiInCart.key] = 1;
        }
      });

      var updateKeys = Object.keys(updates);
      var hasAdds = toAdd.length > 0;
      if (updateKeys.length === 0 && !hasAdds) return Promise.resolve(false);

      var hasRemovals = updateKeys.some(function (k) {
        return updates[k] === 0;
      });
      if (hasAdds || hasRemovals) {
        $('.jsc_cart__checkout').attr('disabled', true);
        $('.jsc_view__cart').attr('disabled', true);
      }

      var parseCartError = function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (body) {
            throw new Error((body && body.message) || response.statusText || 'Cart request failed');
          });
      };

      var lastCartJson = null;

      var postUpdate = function () {
        if (updateKeys.length === 0) return Promise.resolve(null);
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: cartJsonHeaders,
          body: JSON.stringify({ updates: updates }),
        }).then(function (response) {
          if (!response.ok) return parseCartError(response);
          return response.json();
        }).then(function (cart) {
          lastCartJson = cart;
          return cart;
        });
      };

      var postAdd = function () {
        if (!hasAdds) return Promise.resolve(null);
        var items = toAdd.map(function (vid) {
          return {
            id: vid,
            quantity: 1,
            properties: { _Promo: 'Free Gift' },
          };
        });
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: cartJsonHeaders,
          body: JSON.stringify({ items: items }),
        }).then(function (response) {
          if (!response.ok) return parseCartError(response);
          return response.json();
        }).then(function (cart) {
          lastCartJson = cart;
          return cart;
        });
      };

      return postUpdate()
        .then(function () {
          return postAdd();
        })
        .then(function () {
          if (lastCartJson) {
            try {
              $(document).trigger('cart.requestComplete', [lastCartJson]);
            } catch (e) {}
          }
          var drawerVid = hasAdds ? toAdd[toAdd.length - 1] : drawerHintVid;
          if (isNaN(drawerVid) && lastCartJson && lastCartJson.items && lastCartJson.items[0]) {
            drawerVid = lastCartJson.items[0].id;
          }
          if (isNaN(drawerVid)) drawerVid = null;
          return { ran: true, drawerVid: drawerVid };
        });
    })
    .then(function (result) {
      if (!result || !result.ran) return;
      removeCartSpinner();
      if (window.location.pathname === '/cart') {
        location.reload();
        return;
      }
      var cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;
      if (result.drawerVid) {
        updateCartDrawer(result.drawerVid, cartDrawer);
      }
      if (typeof checkGiftWrapInCartFast === 'function') {
        checkGiftWrapInCartFast();
      }
    })
    .catch(function (error) {
      removeCartSpinner();
      console.error('Error:', error);
    });
}
// end: gwp auto add

// start: buy x get y
buyXGetYGwp = () => {
  var _ele = $('.jsc-buy-x-get-y-gwp');
  

  if(_ele.length > 0) {
    _ele.each(function() {
      var _qualifier_vid = parseInt($(this).attr('data-qualifier-vid'));
      var _qualifier_qty = parseInt($(this).attr('data-qualifier-qty'));
      var _gift_vid = parseInt($(this).attr('data-gift-vid'));
      var _gift_qty = parseInt($(this).attr('data-gift-qty'));
      var _index = $(this).attr('data-loop');
      
      fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        // Find qualifoer item in cart
        var qualifier_item_in_cart = data.items.find(item => 
          item.id == _qualifier_vid
        );

        if (qualifier_item_in_cart !== undefined) {
          // Qualifier item in cart
          var qualifier_item_in_cart_qty = qualifier_item_in_cart.quantity;
          
          var complete_sets = Math.floor(qualifier_item_in_cart_qty / _qualifier_qty);
          var final_get_qty = complete_sets * _gift_qty;

          var gift_item_in_cart = data.items.find(item => 
            item.id == _gift_vid && item.properties['_index'] == _index
          );

          if (gift_item_in_cart !== undefined) {
            if (qualifier_item_in_cart_qty < _qualifier_qty) {
              cartJSUpdate(gift_item_in_cart.key, 0, {});
            }

            // Update exisiting gwp qty (ONLY USE FOR EVERY) e.g. For every 2 qualifier item, get 1 gwp, so buy 4 get 2 gwp. then uncomment the code below
            
            // var gift_item_in_cart_qty = gift_item_in_cart.quantity;
            // if (gift_item_in_cart_qty != final_get_qty) {
            //   $('.jsc_cart__checkout').attr('disabled',true);
            //   $('.jsc_view__cart').attr('disabled',true);
            //   cartJSUpdate(gift_item_in_cart.key, final_get_qty, {'_Promo': 'Free Gift', '_index': _index});
            // }

          } else {
            // Add gwp because it's not in cart
              $('.jsc_cart__checkout').attr('disabled',true);
              $('.jsc_view__cart').attr('disabled',true);
              
              if (qualifier_item_in_cart_qty >= _qualifier_qty) {
                cartJSAdd(_gift_vid, _gift_qty, {'_Promo': 'Free Gift', '_index': _index});
              }else{
                $('.jsc_cart__checkout').attr('disabled',false);
                $('.jsc_view__cart').attr('disabled',false);
              }

              // Uncomment the code below if the Promo is on Every Purchase
              // if (final_get_qty != 0) {
              //   cartJSAdd(_gift_vid, final_get_qty, {'_Promo': 'Free Gift', '_index': _index});
              // }
          }

        } else  {
          var gift_item_in_cart = data.items.find(item => 
            item.id == _gift_vid && item.properties['_index'] == _index
          );

          if (gift_item_in_cart !== undefined) {
            // if gwp is in cart but qualifier is not in cart then remove gwp
              $('.jsc_cart__checkout').attr('disabled',true);
              $('.jsc_view__cart').attr('disabled',true);
              cartJSUpdate(gift_item_in_cart.key, 0, {});
          }
        }

      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  }
}
// end: buy x get y

// start: tier GWP
showCartSpinner = () => {
  $('.jsc_cart__checkout').attr('disabled',true);
  $('.jsc_view__cart').prop('outerHTML', $('.jsc_view__cart').prop('outerHTML').replace('<a', '<button').replace('</button>', '</span>'));
  $('.jsc_view__cart').attr('disabled', true);

  var cartItemElement = 'cart-drawer-items';

  // Check if we're on the cart page
  if (window.location.pathname == '/cart') {
    cartItemElement = 'cart-items';
  }

  $(`${cartItemElement}`).addClass('is-loading');

}
removeCartSpinner = () => {
  $('.jsc_cart__checkout').removeAttr('disabled');
  $('.jsc_view__cart').prop('outerHTML', $('.jsc_view__cart').prop('outerHTML').replace('<button', '<a').replace('</button>', '</a>'));
  $('.jsc_view__cart').removeAttr('disabled')
  var cartItemElement = 'cart-drawer-items';

  // Check if we're on the cart page
  if (window.location.pathname == '/cart') {
    cartItemElement = 'cart-items';
  }

  $(`${cartItemElement}`).removeClass('is-loading');

}

autoTierGwp = () => {
  var $tierGwp = $('.jsc-tier-gwp');
  if($tierGwp.length > 0) {
    var tier1Vid = parseInt($tierGwp.attr('data-tier-1-vid'));
    var tier1MinSpend = parseInt($tierGwp.attr('data-tier-1-min-spend'));
    var tier2Vid = parseInt($tierGwp.attr('data-tier-2-vid'));
    var tier2MinSpend = parseInt($tierGwp.attr('data-tier-2-min-spend'));
    var tier3Vid = parseInt($tierGwp.attr('data-tier-3-vid'));
    var tier3MinSpend = parseInt($tierGwp.attr('data-tier-3-min-spend'));
    var excludedProductIds = $tierGwp.attr('data-exclude-vid').split(',').map(id => parseInt(id.trim()));

    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET'
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      var originalPrice = data.original_total_price;
      var excludedTotal = 0;

      // Calculate cart total excluding specific items
      data.items.forEach(item => {
        if (excludedProductIds.includes(item.id)) {
          excludedTotal += item.price * item.quantity; 
        }
      });
      originalPrice = originalPrice - excludedTotal;

      if(originalPrice >= tier3MinSpend) { // tier 3
        // tierAddGwp(tier3Vid, data.items);
        // tierRemoveGwp(tier1Vid, tier2Vid, data.items);
        tierCombineRemoveAddGwp(tier1Vid, tier2Vid, data.items, tier3Vid);
      }
      else if(originalPrice >= tier2MinSpend) { // tier 2
        // tierAddGwp(tier2Vid, data.items);
        // tierRemoveGwp(tier1Vid, tier3Vid, data.items);
        tierCombineRemoveAddGwp(tier1Vid, tier3Vid, data.items, tier2Vid);
      }
      else if(originalPrice >= tier1MinSpend) { // tier 1
        // tierAddGwp(tier1Vid, data.items);
        // tierRemoveGwp(tier2Vid, tier3Vid, data.items);
        tierCombineRemoveAddGwp(tier2Vid, tier3Vid, data.items, tier1Vid);
      }
      else { // not eligible for GWP
        var gwpInCart = data.items.filter(item => (item.id == tier1Vid || item.id == tier2Vid || item.id == tier3Vid) && item.properties && item.properties['_Promo']);
        if(gwpInCart.length > 0) {
          for(let item of gwpInCart) {
            cartJSUpdate(item.key, 0, {});
          }
        }
      }

      var gwpiInCartNoProperty = data.items.filter(item => 
        (item.id == tier1Vid || item.id == tier2Vid || item.id == tier3Vid) && 
        item.properties && !item.properties['_Promo']
      );
      if(gwpiInCartNoProperty.length > 0) {
        for(let item in gwpiInCartNoProperty) {
          showCartSpinner();
          cartJSUpdate(item.key, 0, {});
        }
      }
    })
    .catch(error => {
      console.log(`Error: ${error}`);
    });
  }
}

tierAddGwp = (vid, cartItems) => {
  var gwpInCart = cartItems.find(item => item.id == vid && item.properties && item.properties['_Promo']);
  if(gwpInCart) {
    if(gwpInCart.quantity > 1) {
      showCartSpinner();
      cartJSUpdate(gwpInCart.key, 1, {'_Promo': 'Free Gift'});
    }
  }
  else {
    showCartSpinner();
    cartJSAdd(vid, 1, {'_Promo': 'Free Gift'});
  }
}

tierCombineRemoveAddGwp = (vid1, vid2, cartItems, vid) => {
  var otherGwpInCart = cartItems.filter(item => (item.id == vid1 || item.id == vid2) && item.properties && item.properties['_Promo']);
  var gwpInCart = cartItems.find(item => item.id == vid && item.properties && item.properties['_Promo']);
  var disabledCheckoutBtn = true;

  if(otherGwpInCart.length > 0) {
    console.log('othergwp in cart');
    for(let item of otherGwpInCart) {
      showCartSpinner();
      cartJSUpdate(item.key, 0, {}, disabledCheckoutBtn);
    }
      if(gwpInCart) {
        if(gwpInCart.quantity > 1) {
          showCartSpinner();
          cartJSUpdate(gwpInCart.key, 1, {'_Promo': 'Free Gift'});
        }
      }
      else {
        showCartSpinner();
        cartJSAdd(vid, 1, {'_Promo': 'Free Gift'});
      }
  }
  else{
    console.log('else othergwp in cart');
    if(gwpInCart) {
      if(gwpInCart.quantity > 1) {
        showCartSpinner();
        cartJSUpdate(gwpInCart.key, 1, {'_Promo': 'Free Gift'});
      }
    }
    else {
      showCartSpinner();
      cartJSAdd(vid, 1, {'_Promo': 'Free Gift'});
    }
  }
}

tierRemoveGwp = (vid1, vid2, cartItems) => {
  var otherGwpInCart = cartItems.filter(item => (item.id == vid1 || item.id == vid2) && item.properties && item.properties['_Promo']);
  if(otherGwpInCart.length > 0) {
    for(let item of otherGwpInCart) {
      $('.jsc_cart__checkout').attr('disabled',true);
      $('.jsc_view__cart').attr('disabled',true);
      cartJSUpdate(item.key, 0, {});
    }
  }
}
// end: tier GWP

// start: bundle product
updateBundleVariantOption = (evt) => {
  var variantId = parseInt($(evt).val());
  var $bundleWrap = $('.jsc-bundle-variant-picker').find(`.jsc-bundle-variant-option-wrap[data-main-var-id="${variantId}"]`);
  
  $bundleWrap.siblings('.jsc-bundle-variant-option-wrap').removeClass('active');
  $bundleWrap.addClass('active');
  var $defaultOption = $bundleWrap.find('.jsc-bundle-variant-option:not(.oos)').first();
  if ($defaultOption.length == 0) {
    $defaultOption = $bundleWrap.find('.jsc-bundle-variant-option').first();
  }
  $defaultOption.click();
}

updateBundleVariant = (evt) => {
  var $input = $(evt).find('input[name="jsc-bundle-variant-check"]');
  $input.prop('checked', true);

  // update price
  var priceMoney = $($(evt).attr('price-money')).text();
  $(evt).closest('.product__content').find('.price__regular .money').text(priceMoney);

  // update button
  var isAvailable = $(evt).attr('is-available');
  var bundleAtcBtn = $('.bundle-product__form');
  var bundleBisBtn = $('.bundle-product-bis');
  if (isAvailable == 'true') {
    bundleAtcBtn.css('display', 'grid');
    bundleBisBtn.css('display', 'none');
  }
  else {
    bundleAtcBtn.css('display', 'none');
    bundleBisBtn.css('display', 'inline-block');
  }

  // update smile widget
  var isBundle = $(evt).attr('is-bundle');
  var $fakeSmileWidget = $('.jsc-fake-smile-widget');
  var $appSmileWidget = $fakeSmileWidget.prev('.shopify-app-block');
  if ($appSmileWidget.length > 0) {
    if (isBundle != undefined) {
      var points = parseInt($(evt).attr('product-points'));
      if (points > 0) {
        var isLogin = $fakeSmileWidget.attr('data-customer');
        if (isLogin == 'true') {
          $fakeSmileWidget.find('.jsc-smile-widget-label').html(`Earn ${points} Points when you buy this item.`);
        }
        else {
          $fakeSmileWidget.find('.jsc-smile-widget-label').html(`Members earn ${points} Points when they buy this item. <a href="/account/register/">Sign up</a> or <a href="/account/login/">log in.</a>`);
        }
        $fakeSmileWidget.addClass('show');
      }
      $appSmileWidget.hide();
    }
    else {
      $fakeSmileWidget.removeClass('show');
      $appSmileWidget.show();
    }
  }

  updateBundleMedia($(evt), isBundle);

  // update klaviyo form info
  var $klaviyoForm = $(evt).parents('.jsc-bundle-variant-picker').siblings('.jsc-email-form-modal');
  var $klaviyoButton = $klaviyoForm.find('.jsc-email-form-btn');
  var $klaviyoTitle = $klaviyoForm.find('.jsc-email-form-title');
  var productId = parseInt($(evt).attr('product-id'));
  var productName = $(evt).attr('product-name');
  var variantId = parseInt($(evt).attr('variant-id'));
  var variantName = $(evt).attr('variant-name');
  var variantSku = $(evt).attr('variant-sku');
  var price = parseInt($(evt).attr('price'));

  $klaviyoTitle.text(productName);
  $klaviyoButton.attr('data-product-id', productId);
  $klaviyoButton.attr('data-product-name', productName);
  $klaviyoButton.attr('data-vid', variantId);
  $klaviyoButton.attr('data-variant-name', variantName);
  $klaviyoButton.attr('data-sku', variantSku);
  $klaviyoButton.attr('data-price', price);
}

bundleAtc = (evt) => {
  var $checkedInput = $(evt).closest('.product__content').find('.jsc-bundle-variant-picker .jsc-bundle-variant-option-wrap.active input[name="jsc-bundle-variant-check"]:checked');
  if ($checkedInput.length > 0) {
    var id = parseInt($checkedInput.val());
    var qty = parseInt($(evt).parent('.bundle-product__form').find('.product-selector__quantity .quantity__input').val());
    cartJSAdd(id, qty, {});
  }
}

openEmailForm = () => {
  var emailModal = $('.jsc-email-form-modal');
  emailModal.show();
}

closeEmailForm = () => {
  var emailModal = $('.jsc-email-form-modal');
  emailModal.hide();
}

triggerKlaviyo = (e) => {
  // email input validation
  var email = $(e).siblings('.jsc-email-form-field').find('.jsc-email-input').val();
  var subscriptionCheck = $(e).siblings('#newsletter_subscription').find('#subscribe_for_newsletter');
  var validationMessage = $(e).siblings('.jsc-email-validation');
  var isEmailValid = false;
  if(email.length <= 0) {
    validationMessage.text('Please fill in your email address');
    validationMessage.show();
  }
  else {
    var emailRegex = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (emailRegex.test(email)) {
      validationMessage.hide();
      isEmailValid = true;
    } else {
      validationMessage.text('Please fill a valid email address');
      validationMessage.show();
    }
  }

  // get product data
  if(isEmailValid == true) {
    var productId = $(e).data('product-id');
    var productName = $(e).data('product-name');
    var vid = $(e).data('vid');
    var variantName = $(e).data('variant-name');
    var sku = $(e).data('sku');
    var price = $(e).data('price');

    var item = {
      "ProductID": productId,
      "ProductName": productName,
      "Categories": [],
      "platform": "Shopify",
      "Channels": [
        "EMAIL"
      ],
      "VariantId": vid,
      "VariantName": variantName,
      "SKU": sku,
      "Price": price
    };

    klaviyo.push(['identify', {'$email' : email}]); // determine profile
    klaviyo.push(['track', 'Back in Stock Subscription', item]); // track profile activity

    if (subscriptionCheck.prop('checked')) {
      const subscribePayload = {
        "data": {
          "type": "subscription",
          "attributes": {
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "email": email,
                  "properties": {
                    "newKey": "New Value"
                  }
                },
                "meta": {
                  "patch_properties": {
                    "append": {
                      "newKey": "New Value"
                    },
                    "unappend": {
                      "newKey": "New Value"
                    }
                  }
                }
              }
            }
          },
          "relationships": {
            "list": {
              "data": {
                "type": "list",
                "id": "TX6b9m"
              }
            }
          }
        }
      }

      var subscribeOption = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision":"2024-07-15"
        },
        body: JSON.stringify(subscribePayload),
      };

      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=wHzJ88",subscribeOption)
        .then(result => console.log(result))
        .catch(error => console.log('error', error));
    }

    var submitMessage = $('.jsc-submission-success');
    submitMessage.show();
    $(e).hide();
  }
}

updateBundleMedia = (current_variant, isBundle) => {
  var titleAlt = $(current_variant).attr('product-name').toLowerCase();
  var titleVarAlt = titleAlt + '-' + $(current_variant).attr('variant-name').toLowerCase();
  var $thumbnail_list = $(current_variant).closest('.product__grid').find('.swiper-thumbs-container .swiper-slide'); 

  if (isBundle != undefined) {
    $thumbnail_list.each(function() {
      var mediaAlt = $(this).attr('data-media-alt').toLowerCase();
      if(mediaAlt == titleAlt || mediaAlt == titleVarAlt) {
        var productMedia = document.querySelector('product-media');
        var featuredMediaId = $(this).attr('data-media-id');

        if (productMedia && featuredMediaId) {
          productMedia.setActiveMedia(Number(featuredMediaId));
          return false;
        }
      }
    });
  }
  else {
    var mediaId = $(current_variant).attr('media-id');
    $thumbnail_list.each(function() {
      if($(this).attr('data-media-id') == mediaId) {
        var productMedia = document.querySelector('product-media');
        var featuredMediaId = $(this).attr('data-media-id');

        if (productMedia && featuredMediaId) {
          productMedia.setActiveMedia(Number(featuredMediaId));
          return false;
        }
      }
    });
  }
}
// end: bundle product

// start: gwp sample progress bar
updateMilestonePosition = () => {
  var $progressContainer = $('.jsc-gwp-sample__progress-container');
  if ($progressContainer.length > 0) {
    $progressContainer.each(function() {
      var $milestone = $(this).find('.jsc-gwp-sample-progress__milestone');
      var milestoneCount = $milestone.length;
      
      // space-evenly in center part
      // $milestone.each(function(index) {
      //   var leftValue = ((index + 1) / (milestoneCount + 1)) * 100;
      //   $(this).css('left', leftValue + '%');
      // });
  
      // distribute between 85% length
      // var spacing = 85.0 / milestoneCount;
      // $milestone.each(function(index) {
      //   var leftValue = (index + 1) * spacing;
      //   $(this).css('left', leftValue + '%');
      // });

      var positions = {
        1: [50],
        2: [30, 70],
        3: [20, 50, 80]
      };

      if (positions[milestoneCount]) {
        $milestone.each(function(index) {
          $(this).css('left', positions[milestoneCount][index] + '%');
        });
      }
    });
  }
}

updateGwpSamppleProgress = () => {
  var $progressContainer = $('.jsc-gwp-sample__progress-container');
  if ($progressContainer.length > 0) {
    fetch(window.Shopify.routes.root + 'cart.js',  {
      method: 'GET'
    })
    .then(response => {
      return response.json();
    })
    .then(cart => {
      var cartTotal = cart.original_total_price;

      var currTierCount = parseInt($('.__gwpsample-currenttier_countleft:last').attr('data-count'));
      var currTierCountLeft = parseInt($('.__gwpsample-currenttier_countleft:last').attr('data-countleft'));
    
      if ((currTierCountLeft < 0) || (currTierCount < 1)) {
        var gwpKeylist = $('.__remove-allgwp').attr('data-gwpKeylist');
        if (gwpKeylist){
          removeAllGwpSample(gwpKeylist);
        }
      }

      $progressContainer.each(function(index, $progressCont) {
        var $milestones = $($progressCont).find('.jsc-gwp-sample-progress__milestone');
        $milestones.each(function() {
          var threshold = parseInt($(this).attr('threshold'));
          if (cartTotal >= threshold) {
            $(this).addClass('active');
          }
          else {
            $(this).removeClass('active');
          }
        });

        var $lastActiveMilestone = $($progressCont).find('.jsc-gwp-sample-progress__milestone.active:last');
        // var cartTotal = parseInt($progressContainer.attr('cart-total'));
        var $progressBar = $($progressCont).find('.jsc-gwp-sample-progress__progress');
        var $progressMessage = $($progressCont).find('.jsc-gwp-sample-progress__message');
        var $progressInfo = $($progressCont).find('.jsc-gwp-sample-progress__info-wrap');
        var progress = 0;

        if ($lastActiveMilestone.length > 0) {
          var threshold = parseInt($lastActiveMilestone.attr('threshold'));
          var leftValue = parseFloat($lastActiveMilestone.css('left'));
          var $nextMilestone = $lastActiveMilestone.next('.jsc-gwp-sample-progress__milestone');

          if ($nextMilestone.length == 0) {
            progress = '100%';
            $progressMessage.hide();
          }
          else {
            if (cartTotal > threshold) {
              var nextMilestoneLeftValue = parseInt($nextMilestone.css('left'));
              var nextThreshold = parseInt($nextMilestone.attr('threshold'));
              var amountOverCurrentThreshold = cartTotal - threshold;
              var diffToNextThreshold = nextThreshold - threshold;
              var milestonePercentage = amountOverCurrentThreshold / diffToNextThreshold;
              var middleValue = (nextMilestoneLeftValue - leftValue) * milestonePercentage;

              var temp = leftValue + middleValue;
              progress = temp + 'px';
            }
            else {
              progress = leftValue + 'px';
            }

            // update message
            var remainingAmount = ((nextThreshold - cartTotal) / 100).toFixed(2);
            if ($nextMilestone.is('[free-shipping]')) {
              $progressMessage.text(`You are $${remainingAmount} away from Free Shipping`);
            }
            else if ($nextMilestone.is('[gwp-sample]')) {
              var sample = parseInt($nextMilestone.attr('sample'));
              if (sample == 1) {
                $progressMessage.text(`You are $${remainingAmount} away from ${sample} Complimentary Sample`);
              }
              else {
                $progressMessage.text(`You are $${remainingAmount} away from ${sample} Complimentary Samples`);
              }
            }
            $progressMessage.show();
          }
        }
        else {
          var $firstMilestone = $($progressCont).find('.jsc-gwp-sample-progress__milestone:first');
          if ($firstMilestone.length > 0) {
            var leftValue = parseFloat($firstMilestone.css('left'));
            var threshold = parseInt($firstMilestone.attr('threshold'));
            var milestonePercentage = cartTotal / threshold;
            var temp = leftValue * milestonePercentage;
            progress = temp + 'px';

            // update message
            var remainingAmount = ((threshold - cartTotal) / 100).toFixed(2);
            if ($firstMilestone.is('[free-shipping]')) {
              $progressMessage.text(`You are $${remainingAmount} away from Free Shipping`);
            }
            else if ($firstMilestone.is('[gwp-sample]')) {
              var sample = parseInt($firstMilestone.attr('sample'));
              if (sample == 1) {
                $progressMessage.text(`You are $${remainingAmount} away from ${sample} Complimentary Sample`);
              }
              else {
                $progressMessage.text(`You are $${remainingAmount} away from ${sample} Complimentary Samples`);
              }
            }
            $progressMessage.show();
          }
        }

        $progressBar.css('width', progress);

        // update bottom info
        var $milestones = $($progressCont).find('.jsc-gwp-sample-progress__milestone');
        $milestones.each(function() {
          if ($(this).is('[free-shipping]')) {
            if ($(this).hasClass('active')) {
              $progressInfo.find('.jsc-gwp-sample-progress__info[free-shipping]').addClass('active');
            }
            else {
              $progressInfo.find('.jsc-gwp-sample-progress__info[free-shipping]').removeClass('active');
            }
          }
          else if ($(this).is('[tier-1]')) {
            if ($(this).hasClass('active')) {
              $progressInfo.find('.jsc-gwp-sample-progress__info[tier-1]').addClass('active');
            }
            else {
              $progressInfo.find('.jsc-gwp-sample-progress__info[tier-1]').removeClass('active');
            }
          }
          else if ($(this).is('[tier-2]')) {
            if ($(this).hasClass('active')) {
              $progressInfo.find('.jsc-gwp-sample-progress__info[tier-2]').addClass('active');
              $progressInfo.find('.jsc-gwp-sample-progress__info[tier-1]').removeClass('active');
            }
            else {
              $progressInfo.find('.jsc-gwp-sample-progress__info[tier-2]').removeClass('active');
            }
          }
        });
      });
    });
  }
}
// end: gwp sample progress bar

// start: toggle complementary slider arrow
toggleComplementaryArrow = () => {
  var $section = $('.section-complete-the-set');
  if ($section.length > 0) {
    var $slider = $section.find('complementary-products .card-product-slider__wrapper');
    var $arrows = $section.find('.swiper-buttons');
    setTimeout(() => {
      console.log('timeout toggle arrow', $arrows);
      if ($slider.children().length > 0) {
        $arrows.removeClass('hide');
      }
    }, 1500);
  }
}
// end: toggle complementary slider arrow

enableSliderButton = () => {
  setTimeout(() => {
    var $slider = $('card-slider');
    if ($slider.length > 0) {
      $slider.siblings('.swiper-button--next').removeClass('swiper-button-disabled');
    }
  }, 1000);
}

// Start: gwp collection min qty
gwpColMinCartQty = () => {
  setTimeout(() => {
    var $gwpInfo = $('.jsc-gwp-min-cart-qty');
    if ($gwpInfo.length === 0) return;

    var $accumulate_qty = 0;
    var $purchase_qty = parseInt($gwpInfo.attr('purchaseQty'), 10);
    var $gift_inventory = parseInt($gwpInfo.attr('gift-inventory'), 10);
    var $giftHandle = $gwpInfo.attr('gift-handle');
    var $giftVid = parseInt($gwpInfo.attr('gift-vid'), 10);

    if (isNaN($purchase_qty) || $purchase_qty <= 0) return;

    $('.jsc-cart-item-qtycol').each(function() {
      var $item_qty = parseInt($(this).find('.cart-item__quantity .quantity__input').val(), 10);
      if (!isNaN($item_qty)) {
        $accumulate_qty += $item_qty;
      }
    });

    var $gift_qty = Math.floor($accumulate_qty / $purchase_qty);
    if ($gift_qty > 0) {
      $gift_qty = 1;
    }

    // If gift is unavailable, force target qty to 0 to clean up stale promo gifts.
    if (isNaN($gift_inventory) || $gift_inventory <= 0) {
      $gift_qty = 0;
    }

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        var promoGiftItems = (cart.items || []).filter(item => {
          var $productProps = item.properties || {};
          if ($productProps['_Promo'] != 'Free Gift') return false;

          var itemVid = parseInt(item.id, 10);
          if (!isNaN($giftVid) && itemVid == $giftVid) return true;
          return item.handle == $giftHandle;
        });

        // Not eligible anymore: remove all matching promo gift line items.
        if ($gift_qty <= 0) {
          promoGiftItems.forEach(item => {
            cartJSUpdate(item.key, 0, {});
          });
          return;
        }

        if (promoGiftItems.length === 0) {
          if (!isNaN($giftVid)) {
            cartJSAdd($giftVid, $gift_qty, {'_Promo': 'Free Gift'});
          }
          return;
        }

        // Keep exactly one valid promo line with the expected qty, remove duplicates.
        var primaryGift = promoGiftItems[0];
        if (primaryGift.quantity != $gift_qty) {
          cartJSUpdate(primaryGift.key, $gift_qty, {});
        }

        if (promoGiftItems.length > 1) {
          promoGiftItems.slice(1).forEach(item => {
            cartJSUpdate(item.key, 0, {});
          });
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }, 500);
}
// End: gwp collection min qty

// start: klaviyoFormHeadingUpdate;
klaviyoFormHeadingUpdate = () => {
  const newsletterHeader = $('#newsletter__header');
  const newsletterHeaderLoggedIn = $('#newsletter__loggedin');
  const klaviyoOnsite = localStorage.getItem('klaviyoOnsite');
  // console.log('klaviyoOnsite: ', klaviyoOnsite);
  if (klaviyoOnsite) {
    const parsedValue = JSON.parse(klaviyoOnsite);
    // console.log('XDgXWf parsedValue', parsedValue);
    const isDisabled = parsedValue.viewedForms.modal.disabledForms.hasOwnProperty('XDgXWf');
    console.log('XDgXWf isDisabled', isDisabled);

    if (isDisabled) {
      if (newsletterHeader.length > 0) { newsletterHeader.css('display', 'none'); }
      if (newsletterHeaderLoggedIn.length > 0) { newsletterHeaderLoggedIn.css('display', 'block'); }
    }
  }
}
// end: klaviyoFormHeadingUpdate();

gridATC = (evt, event) => {
  event.stopPropagation();
  event.preventDefault();
  
  var variantId = parseInt($(evt).attr('variant-id'));
  cartJSAdd(variantId, 1, {});
}

gridATCFast = (evt, event) => {
  event.stopPropagation();
  event.preventDefault();

  var variantId = parseInt($(evt).attr('variant-id'), 10);
  if (Number.isNaN(variantId)) {
    return;
  }

  var cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || typeof cartDrawer.getSectionsToRender !== 'function') {
    cartJSAdd(variantId, 1, {});
    return;
  }

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);
  formData.append(
    'sections',
    cartDrawer
      .getSectionsToRender()
      ?.map(section => section.section)
  );
  formData.append('sections_url', window.location.pathname);

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then(response => response.json())
    .then(response => {
      if (response.status) {
        console.log('There was a problem adding to the cart!');
        return;
      }

      if (window.location.pathname === '/cart') {
        location.reload();
        return;
      }

      cartDrawer.renderContents(response);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    });
}

/** Scroll only the grid variant strip; never scrollIntoView (avoids nudging parent carousels / page). */
jscScrollGridVariantPillIntoViewport = btn => {
  const viewport = btn.closest('.jsc-grid-variant-selector-viewport');
  if (!viewport) {
    return;
  }

  const pad = 4;
  const btnRect = btn.getBoundingClientRect();
  const vpRect = viewport.getBoundingClientRect();

  if (btnRect.right > vpRect.right - pad) {
    viewport.scrollLeft += Math.ceil(btnRect.right - vpRect.right + pad);
  } else if (btnRect.left < vpRect.left + pad) {
    viewport.scrollLeft -= Math.ceil(vpRect.left - btnRect.left + pad);
  }
};

jscUpdateGridCardVariantPrice = (root, btn) => {
  const card = root.closest('card-product') || root.closest('.card-product');
  if (!card) {
    return;
  }

  const priceEl = card.querySelector('.card-product__price');
  if (!priceEl) {
    return;
  }

  const priceFormatted = btn.getAttribute('data-price-formatted');
  const compareFormatted = btn.getAttribute('data-compare-formatted') || '';
  if (!priceFormatted) {
    return;
  }

  const container = priceEl.querySelector('.price__container') || priceEl;
  const onSale = compareFormatted !== '';

  if (onSale) {
    priceEl.classList.add('price--on-sale');

    const regularBlock = container.querySelector('.price__regular');
    if (regularBlock) {
      regularBlock.remove();
    }

    let saleBlock = container.querySelector('.price__sale');
    if (!saleBlock) {
      saleBlock = document.createElement('div');
      saleBlock.className = 'price__sale';
      saleBlock.innerHTML =
        '<div class="price__sale-inner"><span class="visually-hidden"></span><del></del><span class="visually-hidden"></span><ins></ins></div>';
      container.appendChild(saleBlock);
    }

    const del = saleBlock.querySelector('del');
    const ins = saleBlock.querySelector('ins');
    if (del) {
      del.textContent = compareFormatted;
    }
    if (ins) {
      ins.textContent = priceFormatted;
    }
  } else {
    priceEl.classList.remove('price--on-sale');

    const saleBlock = container.querySelector('.price__sale');
    if (saleBlock) {
      saleBlock.remove();
    }

    let regularBlock = container.querySelector('.price__regular');
    if (!regularBlock) {
      regularBlock = document.createElement('div');
      regularBlock.className = 'price__regular';
      regularBlock.innerHTML = '<span class="visually-hidden"></span><span></span>';
      container.appendChild(regularBlock);
    }

    const priceSpan = regularBlock.querySelector('span:not(.visually-hidden)');
    if (priceSpan) {
      priceSpan.textContent = priceFormatted;
    }
  }
};

jscGridCardVariantPillClick = (btn, event) => {
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }

  const root = btn.closest('[data-jsc-grid-card]');
  if (!root) {
    return;
  }

  const variantId = btn.getAttribute('data-variant-id');
  const available = btn.getAttribute('data-available') === 'true';

  root.querySelectorAll('.jsc-grid-variant-pill').forEach(pill => {
    const isThis = pill === btn;
    pill.classList.toggle('is-selected', isThis);
    pill.setAttribute('aria-pressed', isThis ? 'true' : 'false');
  });

  const atc = root.querySelector('.jsc-grid-card-atc-cta');
  const notify = root.querySelector('.jsc-grid-card-notify-cta');
  if (atc) {
    atc.setAttribute('variant-id', variantId);
  }
  if (notify) {
    notify.setAttribute('variant-id', variantId);
  }

  if (atc && notify) {
    if (available) {
      atc.classList.remove('jsc-grid-card-cta--hidden');
      notify.classList.add('jsc-grid-card-cta--hidden');
    } else {
      atc.classList.add('jsc-grid-card-cta--hidden');
      notify.classList.remove('jsc-grid-card-cta--hidden');
    }
  }

  jscUpdateGridCardVariantPrice(root, btn);
  jscScrollGridVariantPillIntoViewport(btn);
};

jscInitGridVariantPillScroll = (root = document) => {
  const scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('.jsc-grid-variant-pill.is-selected').forEach(pill => {
    jscScrollGridVariantPillIntoViewport(pill);
  });
};

/** Click-drag + wheel horizontal scroll for variant pill strips (all product grids). */
jscInitGridVariantDragScroll = (root = document) => {
  const scope = root && root.querySelectorAll ? root : document;
  const DRAG_THRESHOLD = 6;

  scope.querySelectorAll('.jsc-grid-variant-selector-viewport:not([data-jsc-variant-drag-scroll])').forEach(viewport => {
    viewport.dataset.jscVariantDragScroll = 'true';

    let activePointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let isDragging = false;
    let suppressPillClick = false;

    const endDrag = e => {
      if (activePointerId === null || e.pointerId !== activePointerId) {
        return;
      }

      suppressPillClick = isDragging;
      isDragging = false;
      activePointerId = null;
      viewport.classList.remove('is-dragging');

      try {
        if (viewport.hasPointerCapture(e.pointerId)) {
          viewport.releasePointerCapture(e.pointerId);
        }
      } catch (err) {
        /* ignore */
      }
    };

    viewport.addEventListener(
      'click',
      e => {
        if (!suppressPillClick || !e.target.closest('.jsc-grid-variant-pill')) {
          return;
        }

        suppressPillClick = false;
        e.preventDefault();
        e.stopImmediatePropagation();
      },
      true
    );

    viewport.addEventListener(
      'pointerdown',
      e => {
        if (e.button !== 0) {
          return;
        }

        suppressPillClick = false;
        activePointerId = e.pointerId;
        startX = e.clientX;
        startScrollLeft = viewport.scrollLeft;
        isDragging = false;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'pointermove',
      e => {
        if (activePointerId === null || e.pointerId !== activePointerId) {
          return;
        }

        const dx = e.clientX - startX;

        if (!isDragging) {
          if (Math.abs(dx) <= DRAG_THRESHOLD) {
            return;
          }
          isDragging = true;
          viewport.classList.add('is-dragging');
          try {
            viewport.setPointerCapture(e.pointerId);
          } catch (err) {
            /* ignore */
          }
        }

        e.preventDefault();
        viewport.scrollLeft = startScrollLeft - dx;
      },
      { passive: false }
    );

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('pointerleave', endDrag);

    viewport.addEventListener(
      'wheel',
      e => {
        if (viewport.scrollWidth <= viewport.clientWidth + 1) {
          return;
        }

        const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
        if (!delta) {
          return;
        }

        viewport.scrollLeft += delta;
        e.preventDefault();
      },
      { passive: false }
    );
  });
};

jscInitGridVariantPillScrollInContext = (root = document) => {
  jscInitGridVariantPillScroll(root);
  jscInitGridVariantDragScroll(root);
};

// Custom Klaviyo BIS Functions

showBisForm = (e) => {
  var $overlay = $('.jsc-bis-form-wrapper .jsc-bis-overlay');
  var $modal = $('.jsc-bis-form-wrapper .jsc-bis-form-modal');
  var $title = $modal.find('.jsc-bis-title');
  var $selector = $modal.find('.jsc-bis-variant-selector');
  var $emailInput = $modal.find('.jsc-bis-email');
  var $message = $modal.find('.jsc-bis-message');
  var productJson = JSON.parse($(e).attr('data-product'));

  // Get current selected variant from the AI block's hidden input
  var currentVariantId = null;
  var $aiBlock = $(e).closest('[class*="ai-parent-featured-product"]');
  if ($aiBlock.length) {
    // Find the variant input using the jsc-selected-variant class
    var $variantInput = $aiBlock.find('.jsc-selected-variant');
    if ($variantInput.length) {
      currentVariantId = $variantInput.val();
    }
  }
  

  $title.text(productJson.title);
  $selector.html('');
  $.each(productJson.variants, function() {
    if(this.available == false) {
      var $option = $('<option></option>').val(this.id).text(this.title);
              // Pre-select the current variant if it's sold out
              if (currentVariantId && this.id == currentVariantId) {
                $option.prop('selected', true);
              }
      $selector.append($option);
    }
  });
  $emailInput.val('');
  $message.removeClass('show');

  $overlay.addClass('active');
  $modal.addClass('active');
}

hideBisForm = () => {
  var $overlay = $('.jsc-bis-form-wrapper .jsc-bis-overlay');
  var $modal = $('.jsc-bis-form-wrapper .jsc-bis-form-modal');

  $overlay.removeClass('active');
  $modal.removeClass('active');
}

subscribeBIS = (e) => {
  var emailRegex = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
  var email = $(e).parents('.jsc-bis-form-modal').find('.jsc-bis-email').val();
  var isEmailValid = false;
  var vid = parseInt($(e).parents('.jsc-bis-form-modal').find('.jsc-bis-variant-selector').val());
  var $message = $(e).parents('.jsc-bis-form-modal').find('.jsc-bis-message');
  var $listCheck = $(e).parents('.jsc-bis-form-modal').find('.jsc-list-checkbox');

  if (emailRegex.test(email)) {
    isEmailValid = true;
    $message.removeClass('show');
  }
  else {
    $message.html('Please input a valid email');
    $message.addClass('jsc-bis-error');
    $message.addClass('show');
  }

  if(isEmailValid == true) {
    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": email
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": "$shopify:::$default:::" + vid
            }
          }
        }
      }
    }

    var requestOptions = {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "revision":"2024-06-15"
      },
      body: JSON.stringify(payload),
    };

    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=wHzJ88",requestOptions)
      .then(result => {
        console.log(result);
        $message.html("You're in! We'll let you know when it's back. <span onclick='hideBisForm();'>Close</span>");
        $message.addClass('jsc-bis-success');
        $message.addClass('show');
      })
      .catch(error => {
        console.log('error', error);
        $message.html("Error occurred! <span onclick='hideBisForm();'>Close</span>");
        $message.addClass('jsc-bis-error');
        $message.addClass('show');
      });

    if($listCheck.is(':checked')) {
      // Use Klaviyo's track method for email list subscription
      if (typeof klaviyo !== 'undefined') {
        klaviyo.push(['track', 'Subscribe to List', {
          '$email': email,
          'source': 'back_in_stock_form'
        }]);
        
        // Also try to identify the profile
        klaviyo.push(['identify', {
          '$email': email
        }]);
      }
    }
  }
}

// start: cart gift wrap
toggleGiftWrapVariantPicker = (evt) => {
  var $variantPicker = $('.jsc-cart-gift-wrap-cont').find('.jsc-cart-gift-wrap-variant-picker');
  var $optionValueText = $variantPicker.find('.jsc-cart-gift-wrap-current-value');
  var $variantOption = $variantPicker.find('.jsc-cart-gift-wrap-option');
  if ($(evt).is(':checked')) {
    $variantPicker.removeClass('d-none');
  }
  else {
    $variantPicker.addClass('d-none');
    $optionValueText.text('');
    $variantOption.removeClass('active');
  }
}

updateGiftWrapVariant = (evt) => {
  if ($(evt).hasClass('gift-wrap-oos')) {
    return;
  }
  var $optionWrap = $(evt).parents('.jsc-cart-gift-wrap-option-wrap');
  var value = $(evt).attr('data-value');
  var $optionValueText = $optionWrap.parents('.jsc-cart-gift-wrap-variant-picker-wrap').find('.jsc-cart-gift-wrap-current-value');
  $optionWrap.find('.jsc-cart-gift-wrap-option').removeClass('active');
  $(evt).addClass('active');
  $optionValueText.text(value);
  updateGiftWrapVariantOption();
  giftWrapATC($(evt));
}

getGiftWrapOption = () => {
  var $giftWrapCont = $('.jsc-cart-gift-wrap-cont');
  var $variantPickerWrap = $giftWrapCont.find('.jsc-cart-gift-wrap-variant-picker-wrap');
  var option1, option2, option3 = null;

  $variantPickerWrap.each(function(index, $variantPicker) {
    var position = $($variantPicker).attr('index');
    var $options = $($variantPicker).find('.jsc-cart-gift-wrap-option');
    
    $options.each(function(index, $option) {
      if ($($option).hasClass('active')) {
        if (position == 1) {
          option1 = $($option).attr('data-value');
        }
        else if (position == 2) {
          option2 = $($option).attr('data-value');
        }
        else if (position == 3) {
          option3 = $($option).attr('data-value');
        }
      }
    });
  });

  return {
    option1: option1,
    option2: option2,
    option3: option3
  }
}

updateGiftWrapVariantOption = () => {
  var optionInfo = getGiftWrapOption();
  var $variantInfo = $('.jsc-cart-gift-wrap-cont .jsc-cart-gift-wrap-variant-info');
  var $variantPickerWrap = $('.jsc-cart-gift-wrap-cont .jsc-cart-gift-wrap-variant-picker-wrap');
  
  // Filter using OR logic: include variants that match ANY non-null option value
  var $filteredVariants = $variantInfo.filter(function() {
    var $element = $(this);
    var matches = false;
    
    // Check if element matches option1 (if option1 has a value)
    if (optionInfo.option1 != null && $element.attr('option-1') === optionInfo.option1) {
      matches = true;
    }
    
    // Check if element matches option2 (if option2 has a value)
    if (optionInfo.option2 != null && $element.attr('option-2') === optionInfo.option2) {
      matches = true;
    }
    
    // Check if element matches option3 (if option3 has a value)
    if (optionInfo.option3 != null && $element.attr('option-3') === optionInfo.option3) {
      matches = true;
    }
    
    return matches;
  });

  // First, show all options
  $('.jsc-cart-gift-wrap-cont .jsc-cart-gift-wrap-option').removeClass('d-none');
  
  // Get all variants with hide-variant="true" (impossible combinations)
  var $hiddenVariants = $variantInfo.filter(function() {
    return $(this).attr('hide-variant') === 'true';
  });
  
  // For each impossible variant, hide options that would create that combination
  $hiddenVariants.each(function(index, variant) {
    var $variant = $(variant);
    var varOpt1 = $variant.attr('option-1');
    var varOpt2 = $variant.attr('option-2');
    var varOpt3 = $variant.attr('option-3');
    
    // Check if current selection matches any part of this impossible variant
    var matchesOption1 = optionInfo.option1 != null && optionInfo.option1 === varOpt1;
    var matchesOption2 = optionInfo.option2 != null && optionInfo.option2 === varOpt2;
    var matchesOption3 = optionInfo.option3 != null && optionInfo.option3 === varOpt3;
    
    // If any option matches, hide the other options from this impossible variant
    if (matchesOption1 || matchesOption2 || matchesOption3) {
      $variantPickerWrap.each(function(index, variantPicker) {
        var $variantPicker = $(variantPicker);
        var position = parseInt($variantPicker.attr('index'));
        var $variantOptions = $variantPicker.find('.jsc-cart-gift-wrap-option');
        
        $variantOptions.each(function(index, option) {
          var $option = $(option);
          var optionValue = $option.attr('data-value');
          var isCurrentlySelected = $option.hasClass('active');
          
          // Don't hide the currently selected option
          if (isCurrentlySelected) {
            return;
          }
          
          // Hide option-2 if we've selected option-1 that matches this impossible variant
          if (position == 2 && varOpt2 === optionValue && matchesOption1) {
            $option.addClass('d-none');
          }
          // Hide option-3 if we've selected option-1 that matches this impossible variant
          else if (position == 3 && varOpt3 === optionValue && matchesOption1) {
            $option.addClass('d-none');
          }
          // Hide option-1 if we've selected option-2 that matches this impossible variant
          else if (position == 1 && varOpt1 === optionValue && matchesOption2) {
            $option.addClass('d-none');
          }
          // Hide option-3 if we've selected option-2 that matches this impossible variant
          else if (position == 3 && varOpt3 === optionValue && matchesOption2) {
            $option.addClass('d-none');
          }
          // Hide option-1 if we've selected option-3 that matches this impossible variant
          else if (position == 1 && varOpt1 === optionValue && matchesOption3) {
            $option.addClass('d-none');
          }
          // Hide option-2 if we've selected option-3 that matches this impossible variant
          else if (position == 2 && varOpt2 === optionValue && matchesOption3) {
            $option.addClass('d-none');
          }
        });
      });
    }
  });
  
  // First, remove all out-of-stock classes
  $('.jsc-cart-gift-wrap-cont .jsc-cart-gift-wrap-option').removeClass('gift-wrap-oos');
  
  // Get all variants with variant-available="false" (out of stock)
  var $unavailableVariants = $variantInfo.filter(function() {
    return $(this).attr('variant-available') === 'false';
  });
  
  // For each unavailable variant, mark options that would create that combination as out of stock
  $unavailableVariants.each(function(index, variant) {
    var $variant = $(variant);
    var varOpt1 = $variant.attr('option-1');
    var varOpt2 = $variant.attr('option-2');
    var varOpt3 = $variant.attr('option-3');
    
    // Check if current selection matches any part of this unavailable variant
    var matchesOption1 = optionInfo.option1 != null && optionInfo.option1 === varOpt1;
    var matchesOption2 = optionInfo.option2 != null && optionInfo.option2 === varOpt2;
    var matchesOption3 = optionInfo.option3 != null && optionInfo.option3 === varOpt3;
    
    // If any option matches, mark the other options from this unavailable variant as out of stock
    if (matchesOption1 || matchesOption2 || matchesOption3) {
      $variantPickerWrap.each(function(index, variantPicker) {
        var $variantPicker = $(variantPicker);
        var position = parseInt($variantPicker.attr('index'));
        var $variantOptions = $variantPicker.find('.jsc-cart-gift-wrap-option');
        
        $variantOptions.each(function(index, option) {
          var $option = $(option);
          var optionValue = $option.attr('data-value');
          var isCurrentlySelected = $option.hasClass('active');
          
          // Don't mark the currently selected option as out of stock
          if (isCurrentlySelected) {
            return;
          }
          
          // Mark option-2 as out of stock if we've selected option-1 that matches this unavailable variant
          if (position == 2 && varOpt2 === optionValue && matchesOption1) {
            $option.addClass('gift-wrap-oos');
          }
          // Mark option-3 as out of stock if we've selected option-1 that matches this unavailable variant
          else if (position == 3 && varOpt3 === optionValue && matchesOption1) {
            $option.addClass('gift-wrap-oos');
          }
          // Mark option-1 as out of stock if we've selected option-2 that matches this unavailable variant
          else if (position == 1 && varOpt1 === optionValue && matchesOption2) {
            $option.addClass('gift-wrap-oos');
          }
          // Mark option-3 as out of stock if we've selected option-2 that matches this unavailable variant
          else if (position == 3 && varOpt3 === optionValue && matchesOption2) {
            $option.addClass('gift-wrap-oos');
          }
          // Mark option-1 as out of stock if we've selected option-3 that matches this unavailable variant
          else if (position == 1 && varOpt1 === optionValue && matchesOption3) {
            $option.addClass('gift-wrap-oos');
          }
          // Mark option-2 as out of stock if we've selected option-3 that matches this unavailable variant
          else if (position == 2 && varOpt2 === optionValue && matchesOption3) {
            $option.addClass('gift-wrap-oos');
          }
        });
      });
    }
  });
}

giftWrapATC = (evt) => {
  var $variantPickerWrap = $(evt).parents('.jsc-cart-gift-wrap-cont').find('.jsc-cart-gift-wrap-variant-picker-wrap');
  var hasEmptyOption = false;

  $variantPickerWrap.each(function(index, variantPicker) {
    var $variantPicker = $(variantPicker);
    var $variantOptions = $variantPicker.find('.jsc-cart-gift-wrap-option');
    var valueSelected = false;

    $variantOptions.each(function(index, option) {
      var $option = $(option);
      if ($option.hasClass('active')) {
        valueSelected = true;
      }
    });

    if (valueSelected == false) {
      hasEmptyOption = true;
    }
  });

  if (hasEmptyOption == false) {
    var optionInfo = getGiftWrapOption();
    var $allVariantInfo = $('.jsc-cart-gift-wrap-cont .jsc-cart-gift-wrap-variant-info');
    
    // Filter to find variant that matches all optionInfo values
    // If optionInfo value is blank, the variant's corresponding option must also be blank
    var $variantInfo = $allVariantInfo.filter(function() {
      var $variant = $(this);
      var varOpt1 = $variant.attr('option-1') || '';
      var varOpt2 = $variant.attr('option-2') || '';
      var varOpt3 = $variant.attr('option-3') || '';
      
      var opt1Value = optionInfo.option1 || '';
      var opt2Value = optionInfo.option2 || '';
      var opt3Value = optionInfo.option3 || '';
      
      // Check if all options match
      var matchesOption1 = varOpt1 === opt1Value;
      var matchesOption2 = varOpt2 === opt2Value;
      var matchesOption3 = varOpt3 === opt3Value;
      
      return matchesOption1 && matchesOption2 && matchesOption3;
    });
    
    var variantId = $variantInfo.attr('variant-id');
    cartJSAdd(variantId, 1, {});
  }
}

// Debounce function to prevent multiple rapid calls (only for cart page)
var checkGiftWrapInCartTimeout;
var lastCheckTime = 0;
var CHECK_DEBOUNCE_DELAY = 500; // Minimum time between checks

// Fast DOM-based check for cart drawer
checkGiftWrapInCartFast = () => {
  var $giftWrapCont = $('.jsc-cart-gift-wrap-cont');
  var $giftWrapCartItems = $('.cart-item.is-gift-wrap');

  if ($giftWrapCont.length > 0) {
    if ($giftWrapCartItems.length > 0) {
      $giftWrapCont.addClass('d-none');
    } else {
      $giftWrapCont.removeClass('d-none');
    }
  }
}

// Debounced API-based check for cart page (slower but more reliable)
checkGiftWrapInCart = () => {
  // Use fast check for cart drawer, API check for cart page
  if (window.location.pathname !== '/cart') {
    checkGiftWrapInCartFast();
    return;
  }
  
  var $giftWrapCont = $('.jsc-cart-gift-wrap-cont');
  
  if ($giftWrapCont.length === 0) {
    return;
  }
  
  var productId = $giftWrapCont.attr('product-id');
  
  if (!productId) {
    return;
  }
  
  // Clear any pending timeout
  if (checkGiftWrapInCartTimeout) {
    clearTimeout(checkGiftWrapInCartTimeout);
  }
  
  // Debounce: only run if enough time has passed since last check
  var now = Date.now();
  var timeSinceLastCheck = now - lastCheckTime;
  var delay = timeSinceLastCheck < CHECK_DEBOUNCE_DELAY ? CHECK_DEBOUNCE_DELAY - timeSinceLastCheck : 0;
  
  checkGiftWrapInCartTimeout = setTimeout(() => {
    lastCheckTime = Date.now();
    
    // Fetch cart state directly from API instead of relying on DOM
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
    })
    .then(response => {
      return response.json();
    })
    .then(cart => {
      // Convert productId to number for comparison
      var productIdNum = parseInt(productId);
      
      // Check if cart contains the gift wrap product
      var productInCart = cart.items.some(function(item) {
        return item.product_id === productIdNum;
      });
      
      // Show or hide the gift wrap container
      if (productInCart) {
        $giftWrapCont.addClass('d-none');
      } else {
        $giftWrapCont.removeClass('d-none');
      }
    })
    .catch(error => {
      console.error('Error checking gift wrap in cart:', error);
      // Fallback to DOM check if API fails
      checkGiftWrapInCartFast();
    });
  }, delay);
}

// Listen for all cart updates
$(document).on('cart.requestComplete', function(event, cart) {
  // Fast check for cart drawer, delayed API check for cart page
  if (window.location.pathname === '/cart') {
    setTimeout(() => {
      checkGiftWrapInCart();
    }, 1500);
  } else {
    // Fast DOM check for cart drawer
    setTimeout(() => {
      checkGiftWrapInCartFast();
    }, 100);
  }
});

// Also listen for cart changes (for cart page updates only)
$(document).on('cart:updated', function() {
  // Only apply to cart page
  if (window.location.pathname === '/cart') {
    setTimeout(() => {
      checkGiftWrapInCart();
    }, 1500);
  }
});
// end: cart gift wrap

// start: remove invalid free items from cart
removeInvalidFreeItems = () => {
  var runCleanup = () => {
  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    var items = data.items || [];

    var invalidFreeItems = items.filter(item => {
      var props = item.properties || {};
      return item.original_line_price <= 0 && !props['_Promo'] && !props['_GWP Sample'];
    });

    var qualifyingNonPromoItems = items.filter(item => {
      var props = item.properties || {};
      return !props['_Promo'] && !props['_GWP Sample'] && item.original_line_price > 0;
    });

    // Safety cleanup: if cart has no qualifying non-promo items left,
    // remove stale promo gifts so cart cannot be left with only _Promo freebies.
    var orphanPromoItems = [];
    if (qualifyingNonPromoItems.length === 0) {
      orphanPromoItems = items.filter(item => {
        var props = item.properties || {};
        return props['_Promo'] == 'Free Gift';
      });
    }

    var removeKeys = new Set();
    invalidFreeItems.forEach(item => removeKeys.add(item.key));
    orphanPromoItems.forEach(item => removeKeys.add(item.key));

    if(removeKeys.size > 0) {
      for (var itemKey of removeKeys) {
        cartJSUpdate(itemKey, 0); 
      }
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
  };

  runCleanup();

  if (window.__jscRemoveInvalidFreeItemsBound) return;
  window.__jscRemoveInvalidFreeItemsBound = true;
  $(document).on('cart.requestComplete cart:updated', function() {
    setTimeout(runCleanup, 200);
  });
}
// end: remove invalid free items from cart

// start: Klaviyo BIS from collection page or product grid
showBisFormFromGrid = (e,event) => {
  event.stopPropagation();
  event.preventDefault();
  var $overlay = $('.jsc-bis-form-wrapper .jsc-bis-overlay');
  var $modal = $('.jsc-bis-form-wrapper .jsc-bis-form-modal');
  var $title = $modal.find('.jsc-bis-title');
  var $emailInput = $modal.find('.jsc-bis-email');
  var $message = $modal.find('.jsc-bis-message');
  var productTitle = $(e).attr('product-title');
  var variantID = $(e).attr('variant-id');

  $title.text(productTitle);
  $modal.find('.jsc-bis-variant').val(variantID);
  $emailInput.val('');
  $message.removeClass('show');

  $overlay.addClass('active');
  $modal.addClass('active');
}
// end: Klaviyo BIS from collection page or product grid

openSearchDrawer = (evt) => {
  setTimeout(() => {
    if(evt.hasAttribute('open')) {
      $(evt).addClass('menu-opening');
  
      var $searchHeaderButton = $(evt).find('#Search-drawer-button-header');
      $searchHeaderButton.addClass('menu-is-open');
      $searchHeaderButton.attr('role', 'button');
      $searchHeaderButton.attr('aria-controls', 'Search-menu-drawer-header');
      $searchHeaderButton.attr('aria-expanded', true);
    
      var $drawerContent = $(evt).find('#Search-menu-drawer-header');
      $drawerContent.css('opacity', 1);
      $drawerContent.css('visibility', 'visible');
      $drawerContent.css('transform', 'none');
    }
    else {
      $(evt).removeClass('menu-opening');
    }
  }, 100);
  
}

updateCartNote = (evt) => {
  var cartNote = $(evt).val();
  CartJS.setNote(cartNote);
}